<div *transloco="let t; read: 'reviewScore'" class="review-score">
  <span class="review-score__badge">{{ score | number : '1.1-1' }}</span>
  <span class="review-score__keyword">{{ t(keyword) }}</span>
  <span class="review-score__reviewers mt-md-0"> ({{ count }} {{ t('label') }}) </span>
</div>
